import React from "react"
import sanityClient from "@sanity/client"
import { store } from "../../config"
import { collectionFragment } from "../queries/groq"
import { objectCustomImage } from "../queries/groq/partials"
import { GetServerDataProps, PageProps } from "gatsby"

import Template from "@app/components/Collection/Collection"

export type Props = PageProps<GatsbyTypes.TemplateCollectionQuery, GatsbyTypes.TemplateCollectionQueryVariables>

export async function getServerData(context: GetServerDataProps) {
  const {
    pageContext: { handle },
  } = context

  const client = sanityClient({
    dataset: store.sanityDataset,
    projectId: store.sanityProjectId,
    apiVersion: store.sanityApiVersion,
    token: store.sanityToken,
    useCdn: true,
  })

  try {
    const response = await client.fetch(`
      {
        "collection": *[_type == "collection" && shopify.handle == "${handle}"][0] {
          metadata {
            ...,
            ${objectCustomImage} 
          },
          ${collectionFragment},
          parentCollection {
            ${collectionFragment}
          }
        },
        "template": *[_type == "templateCollection"][0] {
          metadata {
            ...,
            ${objectCustomImage} 
          },
          additionalLoadMoreButton,
          settingShowSubCollections
        }
      }
    `)
    return {
      status: 200,
      props: response,
    }
  } catch (error) {
    console.log((error as Error).message)
    return {
      status: 500,
    }
  }
}
const Component: React.FC<Props> = ({ serverData, ...props }) => <Template {...props} {...serverData} />
export default Component
